export const defaultSeatingDomainState = {
    areaCategories: {},
    seatLayouts: {},
    seatAvailabilities: {}
};
